export const FIND_CARE_PROVIDER_REQUEST = 'FIND_CARE_PROVIDER_REQUEST';

export const findCareProviderRequest = ( id ) => ({
    type: FIND_CARE_PROVIDER_REQUEST,
    payload: { id }
});
